import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { checkNotAdmin } from "utils/utils";
import store from "./store/store";
import adminStore from "./store/adminStore";

ReactDOM.createRoot(document.getElementById("root")).render(
  <Provider store={checkNotAdmin() ? store : adminStore}>
    <App />
  </Provider>
);
